import calendarEventApi from "~/api/calendar_event";
import appointmentApi from "~/api/online_afspraken_appointment";

const showModal = ({ commit }, {
  appointmentId, calendarEventId, customerId, startTime, endTime,
}) => {
  if (calendarEventId) {
    calendarEventApi.find(calendarEventId, customerId ? "customer" : null).then((response) => {
      commit("SET_MODAL_CALENDAR_EVENT", response.data);
    }).catch(() => {
      this.$notification.error({
        message: "Er ging iets mis",
        description: "Het is niet gelukt om de afspraak te laden",
      });
    });
  } else if (appointmentId) {
    appointmentApi.find(appointmentId, customerId ? "customer" : null).then((response) => {
      commit("SET_MODAL_APPOINTMENT", response.data);
    }).catch(() => {
      this.$notification.error({
        message: "Er ging iets mis",
        description: "Het is niet gelukt om de afspraak te laden",
      });
    });
  } else {
    const calendarEvent = {
      customer_id: customerId,
      time_start: startTime,
      time_end: endTime,
    };
    commit("SET_MODAL_APPOINTMENT", calendarEvent);
    commit("SET_MODAL_CALENDAR_EVENT", calendarEvent);
  }
};

const hideModal = ({ commit }) => {
  commit("SET_MODAL_CALENDAR_EVENT", null);
  commit("SET_MODAL_APPOINTMENT", null);
};

export default {
  showModal,
  hideModal,
};
